import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, Validation, NestedProperty } from "../../decorators/EntityDecorators";
import { FSTREAM_Image } from "./FSTREAM_Image.model";
import { PointOfService } from "./PointOfService.model";
import { Employee } from "./Employee.model";
import { EmployeePresenceTemplate } from "./EmployeePresenceTemplate.model";

export class EmployeePresenceInstance extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  employeePresenceInstanceID!: number;

  fK_Image_Signature?: number;

  signatureDate?: Date;

  fK_Image_Form?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  iD_SP!: number;

  symptoms?: boolean;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({ maxLength: 255 })
  requester!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  status!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({ maxLength: 255 })
  title!: string;

  description?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_Employee!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_Template!: number;

  officeDate?: Date;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  notificationType!: number;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageSignature?: FSTREAM_Image;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageForm?: FSTREAM_Image;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NestedProperty({ TargetType: Employee })
  employee?: Employee;

  @NestedProperty({ TargetType: EmployeePresenceTemplate })
  template?: EmployeePresenceTemplate;

  GetType(): IEntityMetaData {
    return EmployeePresenceInstance.getMetaData();
  }
}
